import * as Dialog from '@/components/ui/dialog'
import { IconButton } from '@/components/ui/icon-button'
import { X } from 'lucide-solid'
import { type Component, type ComponentProps, type JSX, type ParentComponent, Show } from 'solid-js'
import { Portal } from 'solid-js/web'
import { css } from 'styled-system/css'
import { Box } from 'styled-system/jsx'


export const DialogContainer: ParentComponent<{
  setIsOpen: (value: boolean) => void
  isOpen: boolean
  title?: string
  closeOnInteractOutside?: boolean
  description?: string
  padding?: ComponentProps<typeof Dialog.Content>['p']
} & Dialog.RootProps> = (props) => {
  return (
    <Dialog.Root
      {...props}
      closeOnInteractOutside={props.closeOnInteractOutside || true}
      open={props.isOpen}
      onOpenChange={({ open }) => props.setIsOpen(open)}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner overflow="hidden">
          <Dialog.Content
            display="grid"
            gap={3}
            p={6}
          >
            <Show when={props.title}>
              <Dialog.Title>{props.title}</Dialog.Title>
            </Show>
            <Show when={props.description}>
              <Dialog.Description color='fg.emphasized'>{props.description}</Dialog.Description>
            </Show>
            <Box height="100%" minHeight={0}>{props.children}</Box>
            <Dialog.Trigger
              m={1}
              asChild={(props) => (
                <IconButton
                  {...props}
                  class={css({
                    position: 'absolute',
                    top: '2',
                    right: '2',
                  })}
                  colorPalette="bg"
                  variant="subtle"
                  size="xs"
                  h="6"
                  w="6"
                  minW="2px"
                >
                  <X />
                </IconButton>
              )}
            />
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  )
}
